import {
  formatDateToString,
  formatToCurrencyTypeFloor,
  formatToCurrencyTypeToFixed,
} from "helper/common";
import moment from "moment";
import React from "react";
import {CURRENCY_LOCALE, FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    width: 40,
    align: "center",
  },
  {
    title: "Số lô",
    dataIndex: "soLo",
    show: true,
    align: "left",
    width: 160,
  },

  {
    title: "Mã vật tư",
    dataIndex: "vtytid",
    show: true,
    align: "center",
    width: 80,
  },
  {
    title: "Tên theo thương mại",
    dataIndex: "tenTheoThuongMai",
    show: true,
    align: "center",
    width: 120,
  },
  {
    title: "Ngày hết hạn",
    dataIndex: "ngayHetHan",
    show: false,
    align: "center",
    render(value, record, index) {
      return <>{formatDateToString(moment(value), FORMAT_TIME.dayFull)}</>;
    },
  },
  {
    title: "Đơn giá bán",
    dataIndex: "donGiaXuat",
    show: true,
    align: "right",
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
    width: 100,
  },
  {
    title: "SL nhập",
    dataIndex: "soLuong",
    show: true,
    align: "right",
  },
  {
    title: "SL xuất",
    dataIndex: "soLuong",
    show: true,
    align: "right",
  },
  {
    title: "SL dự trù",
    dataIndex: "soLuong",
    show: true,
    align: "right",
  },
  {
    title: "Đơn giá nhập",
    dataIndex: "donGiaNhap",
    show: true,
    align: "right",
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
    width: 100,
  },
  {
    title: "VAT",
    dataIndex: "vat",
    show: true,
    align: "center",
  },
  {
    title: "Discount",
    dataIndex: "discount",
    show: true,
    align: "right",
  },
  {
    title: "Tổng tiền",
    dataIndex: "giaTriHang",
    show: true,
    render(value, record, index) {
      return (
        <>{formatToCurrencyTypeToFixed(value, 0, CURRENCY_LOCALE.TYPE_DE)}</>
      );
    },
    align: "right",
  },
  {title: "Ghi chú", dataIndex: "ghiChu", show: true, align: "center"},
];
export {columns};
